/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Build settings that control how the app is built.
 *
 * @remarks
 * Omitted until the environment has build settings.
 */
export type EnvironmentBuild = {
  /**
   * Path to the Dockerfile used to build the app, if any.
   *
   * @remarks
   */
  dockerfile?: string | undefined;
  /**
   * The directory the app is built from. "." for the repository root.
   *
   * @remarks
   */
  rootDirectory: string;
  /**
   * Overrides the build command auto-detected by Railpack, so monorepos can
   *
   * @remarks
   * scope the build to a single app. Omitted when left to auto-detection or
   * for Dockerfile builds.
   */
  buildCommand?: string | undefined;
  /**
   * Paths that trigger a rebuild when changed.
   *
   * @remarks
   */
  watchPaths: Array<string>;
  /**
   * Whether pushes automatically trigger a deployment.
   *
   * @remarks
   */
  autoDeploy: boolean;
};

/** @internal */
export const EnvironmentBuild$inboundSchema: z.ZodType<
  EnvironmentBuild,
  z.ZodTypeDef,
  unknown
> = z.object({
  dockerfile: z.string().optional(),
  rootDirectory: z.string(),
  buildCommand: z.string().optional(),
  watchPaths: z.array(z.string()),
  autoDeploy: z.boolean(),
});

export function environmentBuildFromJSON(
  jsonString: string,
): SafeParseResult<EnvironmentBuild, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EnvironmentBuild$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EnvironmentBuild' from JSON`,
  );
}
